import { useRoute, useRouter } from 'vue-router'
import { ref, watch } from 'vue'

export function useRoutedRef() {
  const route = useRoute()
  const router = useRouter()
  const model = ref(route.name)
  watch(model, name => router.push({ name }))

  return model
}
